var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * API service for import batch operations.
 */
import { getHeaders } from './apiUtils';
import { API_PATHS, CZNA_AUTHORITIES_IMPORT_BATCH_ITEMS, CZNA_AUTHORITIES_IMPORT_BATCH_ITEM_DETAIL, CZNA_AUTHORITIES_IMPORT_BATCH_PROTOCOL, } from '../types/apiPaths';
var DEFAULT_BATCH_LIMIT = 50;
/**
 * CZNA-1343 — the import stages in execution order and the current derivation rules.
 */
export var fetchImportPipeline = function (ky) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (ky.get(API_PATHS.CZNA_AUTHORITIES_IMPORT_PIPELINE, { headers: getHeaders() })
                .json())];
    });
}); };
var DEFAULT_ITEM_LIMIT = 100;
/**
 * Fetches import batches with offset pagination.
 */
export var fetchBatches = function (ky_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1], args_1, true), void 0, function (ky, params) {
        var searchParams;
        var _a, _b;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_c) {
            searchParams = new URLSearchParams();
            searchParams.set('offset', String((_a = params.offset) !== null && _a !== void 0 ? _a : 0));
            searchParams.set('limit', String((_b = params.limit) !== null && _b !== void 0 ? _b : DEFAULT_BATCH_LIMIT));
            return [2 /*return*/, ky.get("".concat(API_PATHS.CZNA_AUTHORITIES_IMPORT_BATCHES, "?").concat(searchParams), {
                    headers: getHeaders(),
                }).json()];
        });
    });
};
/**
 * Fetches items for a specific import batch, with optional status filter.
 */
export var fetchBatchItems = function (ky_1, batchId_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1, batchId_1], args_1, true), void 0, function (ky, batchId, params) {
        var searchParams;
        var _a, _b;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_c) {
            searchParams = new URLSearchParams();
            if (params.status)
                searchParams.set('status', params.status);
            searchParams.set('offset', String((_a = params.offset) !== null && _a !== void 0 ? _a : 0));
            searchParams.set('limit', String((_b = params.limit) !== null && _b !== void 0 ? _b : DEFAULT_ITEM_LIMIT));
            return [2 /*return*/, ky.get("".concat(CZNA_AUTHORITIES_IMPORT_BATCH_ITEMS(batchId), "?").concat(searchParams), {
                    headers: getHeaders(),
                }).json()];
        });
    });
};
/**
 * CZNA-1344 — the stage protocol of one import: each stage's outcome and results.
 */
export var fetchBatchProtocol = function (ky, batchId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (ky.get(CZNA_AUTHORITIES_IMPORT_BATCH_PROTOCOL(batchId), { headers: getHeaders() })
                .json())];
    });
}); };
/**
 * Fetches full detail for a specific import batch item, including source record data.
 */
export var fetchBatchItemDetail = function (ky, batchId, itemId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.get(CZNA_AUTHORITIES_IMPORT_BATCH_ITEM_DETAIL(batchId, itemId), {
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * Trigger an NK Tritius authority import. Backend downloads the XML.gz from the
 * NKP host (allow-listed) and starts the async import. Returns the new batch id.
 */
export var startImportFromNkp = function (ky, sourceUrl, duplicateStrategy) { return __awaiter(void 0, void 0, void 0, function () {
    var search;
    return __generator(this, function (_a) {
        search = new URLSearchParams();
        search.set('sourceUrl', sourceUrl);
        search.set('duplicateStrategy', duplicateStrategy);
        return [2 /*return*/, ky.post("czna-authorities/import/start-from-nkp?".concat(search), { headers: getHeaders() }).json()];
    });
}); };
/**
 * CZNA-1106 — upload a file for the two-step import on the Authorities screen.
 * The backend stores it under `name` (its sanitized base name) and the later
 * preview / start / delete calls address it by that same name.
 *
 * No `getHeaders()` here: it pins `Content-Type: application/json`, and a
 * multipart body needs the browser to write its own content type, boundary
 * included.
 */
export var uploadImportFile = function (ky, file, name) { return __awaiter(void 0, void 0, void 0, function () {
    var body;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                body = new FormData();
                body.append('file', file, name);
                return [4 /*yield*/, ky.post('czna-authorities/import/upload', { body: body })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
/**
 * CZNA-1106 — dry run of an uploaded file: what the import WOULD do with the
 * given strategy. Writes nothing; the file stays uploaded for the next step.
 */
export var previewImport = function (ky, fileName, duplicateStrategy) { return __awaiter(void 0, void 0, void 0, function () {
    var search;
    return __generator(this, function (_a) {
        search = new URLSearchParams();
        search.set('fileName', fileName);
        search.set('duplicateStrategy', duplicateStrategy);
        return [2 /*return*/, ky.post("czna-authorities/import/preview?".concat(search), 
            // The stripes client cuts a request at 30 s; Kong's own read timeout is 60 s
            // and holds regardless. Lifting the client cap buys a dry run the full 60 s
            // Kong allows. For scale: CZNA-1106 measured 5.1 s for a 10 000-record file (the
            // export ceiling; 5 000 new, 5 000 already stored, half of them changed) against
            // a Testcontainers Postgres — synthetic records and a near-empty database, so a
            // lower bound, not the production figure.
            { headers: getHeaders(), timeout: false }).json()];
    });
}); };
/**
 * CZNA-1106 — the confirmed second step: start the real import of an uploaded
 * file. The backend deletes the file once the batch finishes.
 */
export var startImportFromFile = function (ky, fileName, duplicateStrategy) { return __awaiter(void 0, void 0, void 0, function () {
    var search;
    return __generator(this, function (_a) {
        search = new URLSearchParams();
        search.set('fileName', fileName);
        search.set('duplicateStrategy', duplicateStrategy);
        return [2 /*return*/, ky.post("czna-authorities/import/start?".concat(search), { headers: getHeaders() }).json()];
    });
}); };
/**
 * CZNA-1106 — discard an uploaded file the cataloguer rejected after the
 * preview, so it does not linger in the module's temp dir.
 */
export var deleteImportFile = function (ky, fileName) { return __awaiter(void 0, void 0, void 0, function () {
    var search;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                search = new URLSearchParams();
                search.set('fileName', fileName);
                return [4 /*yield*/, ky.delete("czna-authorities/import/file?".concat(search), { headers: getHeaders() })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
/**
 * Look up the currently running import batch. Returns null when none exists
 * (backend returns 404 in that case).
 */
export var getActiveBatchId = function (ky) { return __awaiter(void 0, void 0, void 0, function () {
    var e_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ky.get('czna-authorities/import/batches/active', { headers: getHeaders() }).json()];
            case 1: return [2 /*return*/, _b.sent()];
            case 2:
                e_1 = _b.sent();
                if (((_a = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _a === void 0 ? void 0 : _a.status) === 404)
                    return [2 /*return*/, null];
                throw e_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
